<mat-card class="example-card biggest-container">
  <mat-card-header class="titreFrm">
    <mat-card-title>Liste document</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <mat-card class="example-card carClass">
      <mat-card-content>
        <!-- Filtrer -->
        <div class="btn">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="dateDebut"
              placeholder="Du"
              [(ngModel)]="date_Debut"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dateDebut"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateDebut></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="dateFin"
              placeholder="Au"
              [(ngModel)]="date_Fin"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dateFin"
            ></mat-datepicker-toggle>
            <mat-datepicker #dateFin></mat-datepicker>
          </mat-form-field>
          <div>
            <button
              type="button"
              (click)="getListeDocument()"
              mat-raised-button
              class="colorGreen button-row"
            >
              <mat-icon>search</mat-icon>Filtrer
            </button>
          </div>
        </div>
        <!-- LISTE COMMANDE -->

        <!-- detail commande -->
        <div style="display: flex">
          <div style="width: 630px">
            <h2>Liste commandes</h2>
            <app-liste
              #listeDocumentComponen
              [heightTable]="'400'"
              [dataSourceBrut]=""
              (btnTable)="clickBtnHeat($event)"
              (outputAction)="outputActionListeHeurSemaineComponent($event)"
              [displayedColumnsBrut]="columns"
            >
            </app-liste>
          </div>
          <div *ngIf="commande.length > 0" style="padding-left: 0.5rem">
            <h2>Client</h2>

            <div class="btn">
              <div>
                <div>
                  <b>Entreprise: </b>
                  {{ lastDoc?.Doc_RS }}
                </div>
                <br />
                <div>
                  <b>Tél: </b>
                  {{ lastDoc?.Tiers_code }}
                </div>
                <br />
                <div>
                  <b>Adresse: </b>
                  {{ lastDoc?.Doc_Adresse }}
                </div>
              </div>
              <div style="margin-left: 0.5rem">
                <div>
                  <b>Client: </b>
                  {{ lastDoc?.Doc_Param3 }}
                </div>
                <br />
                <div>
                  <b>Email: </b>
                  {{ lastDoc?.Doc_Param2 }}
                </div>
                <br />
                <div>
                  <b>Ville: </b>
                  {{ lastDoc?.Doc_Param4 }}
                </div>
              </div>
            </div>
            <br />
            <div>
              <span *ngIf="lastDoc?.Doc_Obs">
                <b>Notes de commande :</b> {{ lastDoc?.Doc_Obs }}
              </span>
            </div>
            <br />
            <h2>BC : {{ commande[0]?.Doc_Num }}</h2>
            <table
              *ngIf="commande.length > 0"
              border="4"
              cellspacing="4"
              cellpadding="4"
            >
              <thead>
                <tr>
                  <th>Code article</th>
                  <th>Libellé</th>
                  <th>Prix ​​unitaire</th>
                  <th>Qte</th>
                  <!-- <th>Poid</th> -->
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let article of commande">
                  <td class="cart_description">
                    {{ article.Art_Code }}
                  </td>
                  <td class="cart_description">
                    {{ article.Art_Des }}
                  </td>

                  <td class="price">
                    <span>{{ article.DocD_PUHTN | number : "1.3-3" }} D</span>
                  </td>

                  <td class="qty">
                    {{ article.DocD_Q }}
                  </td>
                  <!-- <td class="qty">
                    {{article.DocD_PoidsU}}
                  </td> -->
                  <td class="price">
                    <span
                      >{{
                        article.DocD_PUHTN * article.DocD_Q | number : "1.3-3"
                      }}
                      D</span
                    >
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4"><strong>Total</strong></td>
                  <td>
                    <strong>{{ getTotal() }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
            <div
              *ngIf="generalService.cuurentUser == 'BIGDAR'"
              style="margin-bottom: 1rem"
            >
              <span
                style="
                  margin-bottom: 2rem;
                  font-size: 18px;
                  font-family: 'FontAwesome';
                  color: red;
                  padding-left: 10px;
                "
                >Frais de livraison :
                <span>{{ fraisLivraisonBigDar() | number : "1.3-3" }} DT</span>
              </span>
            </div>
            <div *ngIf="generalService.cuurentUser == 'SNCT'">
              <span
                style="
                  font-size: 15px;
                  color: red;
                  font-weight: 500;
                  padding-left: 10px;
                  margin-top: 15px;
                "
                *ngIf="lastDoc.Doc_Param1"
                >{{
                  lastDoc.Doc_Param1 == "1"
                    ? "Livraison à domicile :"
                    : "Retrait magasin"
                }}
                <!-- <span *ngIf="!hasZeroValue() && lastDoc.Doc_Param1==1"> {{fraisLiv(this.poid)!='Sur demande'?fraisLiv(this.poid)+'.000':fraisLiv(this.poid) }} </span>
              <span *ngIf="hasZeroValue()&& lastDoc.Doc_Param1==1">Sur demande </span> -->
              </span>
              <div
                *ngIf="lastDoc.Doc_Param1 == '1'"
                style="margin-bottom: 1rem"
              >
                <span
                  style="
                    margin-bottom: 2rem;
                    font-size: 18px;
                    font-family: 'FontAwesome';
                    color: red;
                    padding-left: 10px;
                  "
                  >Frais de livraison :
                  <span *ngIf="!hasZeroValue() && !transportZero()">
                    {{
                      fraisLiv(this.poid) != "Sur demande"
                        ? fraisLiv(this.poid) + ".000"
                        : fraisLiv(this.poid)
                    }}
                  </span>
                  <span *ngIf="hasZeroValue() || transportZero()"
                    >Sur demande
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- <mat-accordion>
                <mat-expansion-panel hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                 
                  
                </mat-expansion-panel>
            </mat-accordion> -->
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
